import dayjs from 'dayjs';
export const FORM_PRODUCT_DATA = ({ mobileBrandList, channelBuyList }) => {
  return [
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์ (Mobile phone number)',
      type: 'INPUT_PHONE',
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
      disabled: true,
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล (Name - Surname)',
      type: 'INPUT',
      rules: {
        required: true,
      },
    },

    {
      name: 'productId',
      type: 'HIDDEN',
    },

    {
      name: 'warrantyNumberCode',
      label: 'รหัสรับประกัน (Warranty Code)',
      type: 'INPUT',
      disabled: true,
    },

    {
      name: 'barcodeShortcut',
      label: 'รหัสบาร์โค้ด',
      type: 'INPUT_BARCODE_DISPLAY',
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
      disabled: true,
      style: { textAlign: 'center' },
      inputStyle: { textAlign: 'center' },
    },
    {
      name: 'productNameTh',
      label: 'ชื่อสินค้า',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'productTypeName',
      label: 'ประเภทสินค้า',
      type: 'INPUT',
      rules: {
        required: true,
      },
      disabled: true,
    },
    {
      name: 'channelBuyId',
      label: 'ซื้อผ่านช่องทาง (Purchase channel)',
      type: 'DROPDOWN',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
    },

    {
      name: 'mobileBrandId',
      label: 'ยี่ห้อ (Brand)',
      type: 'DROPDOWN',
      properties: {
        options: mobileBrandList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'mobileModelName',
      label: 'รุ่น (Model)',
      type: 'INPUT',
      rules: {
        required: true,
      },
    },
    {
      name: 'purchaseDate',
      label: 'วันที่ซื้อ',
      type: 'DATE_PICKER',
      rules: {
        required: true,
      },
      disabledDate: (current) => current && current.isAfter(dayjs(), 'day'),
    },
  ];
};
export const FORM_SHOW_IMAGE_WARRANTY = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'packageImage',
      label: 'ภาพสินค้า (.png, .jpg, .jpeg, .heic) ',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาถ่ายภาพหรือเลือกภาพสินค้า',
        },
      },
      accept: accept.join(','),
    },
  ];
};
export const FORM_PIC = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'invImage',
      label: 'รูปภาพใบเสร็จ (.png, .jpg, .jpeg, .heic)',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาแนบรูปภาพใบเสร็จ',
        },
      },
      accept: accept.join(','),
      maxCount: 1,
    },
  ];
};
